import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";
import LoginButton from "../Google/Auth0/LoginButton";
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
} from "reactstrap";
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/logo.svg";
import lightlogo from "../../assets/images/logo-light.svg";
import logoRombo from "../../assets/images/logo-black.png";
import i18n from "../../i18n";
import { orgId } from "../../constants/utils";

const Login = (props) => {
  document.title = `${i18n.t("Login")} - ${orgId}`;

  return (
    <Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col xs={8}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">{i18n.t("Login")}</h5>
                        <p>{i18n.t("LoginRombo")}</p>
                      </div>
                    </Col>
                    <Col className="col-4 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="auth-logo">
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={lightlogo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                    <Link to="/" className="auth-logo-dark">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <div className="text-center">
                      <img
                        src={logoRombo}
                        alt=""
                        className=""
                        height="200"
                      />
                    </div>                    
                    <div className="mt-3 d-grid">
                      <LoginButton props={props}></LoginButton>
                    </div>
                    <div className="mt-4 text-center">
                      <span>{i18n.t("AcceptTerms")}</span>{" "}
                      <Link to="#" className="text-muted">
                        {i18n.t("TermsOfUse")}
                      </Link>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {i18n.t("ForgotPassword")}{" "}
                  <Link to="/forgot-password" className="fw-medium text-primary">
                    {i18n.t("RecoverPassword")}
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Rombo
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
